// extracted by mini-css-extract-plugin
export default {"Gameplay":"Gameplay_Gameplay__s6MZz","Question":"Gameplay_Question__4jI2P","LineWrapper":"Gameplay_LineWrapper__EvoIZ"};